// src/Services/companyReceivingAccountService.js

import adminAxiosInstance from "./api/adminAxiosInstance";

/** Tipos de chave PIX. O backend espera o nome do enum (string). */
const PixKeyType = {
  CNPJ: "CNPJ",
  EMAIL: "EMAIL",
  CHAVE_ALEATORIA: "CHAVE_ALEATORIA",
  TELEFONE: "TELEFONE",
};

/** Rótulos amigáveis para exibição na tela. */
const PixKeyTypeLabels = {
  CNPJ: "CNPJ",
  EMAIL: "E-mail",
  CHAVE_ALEATORIA: "Chave Aleatória",
  TELEFONE: "Telefone",
};

/** Busca todas as contas de recebimento (ativas e inativas). */
const getAll = async () => {
  const response = await adminAxiosInstance.get("companyreceivingaccount");
  return response.data;
};

/**
 * Cria uma nova conta de recebimento.
 * @param {object} data - { beneficiary, beneficiaryCnpj, bank, agency, accountNumber, pixKey, pixKeyType }
 */
const create = async (data) => {
  const response = await adminAxiosInstance.post("companyreceivingaccount", data);
  return response.data;
};

/** Atualiza os dados de uma conta existente. */
const update = async (id, data) => {
  const payload = { ...data, id };
  await adminAxiosInstance.put(`companyreceivingaccount/${id}`, payload);
};

/** Ativa/desativa uma conta (soft delete). */
const setActive = async (id, isActive) => {
  await adminAxiosInstance.patch(`companyreceivingaccount/${id}/status`, { isActive });
};

export const companyReceivingAccountService = {
  getAll,
  create,
  update,
  setActive,
  PixKeyType,
  PixKeyTypeLabels,
};
